var map = {
	"./backgrounds/arrival.jpg": 164,
	"./backgrounds/clock/defendant.png": 165,
	"./backgrounds/clock/defendant2.png": 166,
	"./backgrounds/clock/documents.png": 167,
	"./backgrounds/clock/judge-asks.png": 168,
	"./backgrounds/clock/legal-team-defendant.png": 169,
	"./backgrounds/clock/legal-team-defendant2.png": 170,
	"./backgrounds/clock/legal-team-prosecutor.png": 171,
	"./backgrounds/clock/legal-team-prosecutor2.png": 172,
	"./backgrounds/clock/sentencing.png": 173,
	"./backgrounds/clock/voting.png": 174,
	"./backgrounds/clock/welcome.png": 175,
	"./backgrounds/clock/witnesses.png": 176,
	"./backgrounds/defendant-1-2.jpg": 177,
	"./backgrounds/defendant-1-3.jpg": 178,
	"./backgrounds/defendant-1.jpg": 179,
	"./backgrounds/defendant-2.jpg": 180,
	"./backgrounds/defendant-defendant.jpg": 181,
	"./backgrounds/defendant-legal-team-defendant.jpg": 182,
	"./backgrounds/defendant-prosecutor.jpg": 183,
	"./backgrounds/defendant2-defendant.jpg": 184,
	"./backgrounds/depature.jpg": 185,
	"./backgrounds/documents-1.jpg": 186,
	"./backgrounds/documents-prosecutor.jpg": 187,
	"./backgrounds/intro-1.jpg": 188,
	"./backgrounds/legal-team-defendant.jpg": 189,
	"./backgrounds/legal-team-defendant2-legal-team-defendant.jpg": 190,
	"./backgrounds/legal-team-prosecutor.jpg": 191,
	"./backgrounds/paper/defendant.png": 192,
	"./backgrounds/paper/defendant2.png": 193,
	"./backgrounds/paper/documents.png": 194,
	"./backgrounds/paper/judge-asks.png": 195,
	"./backgrounds/paper/legal-team-defendant.png": 196,
	"./backgrounds/paper/legal-team-defendant2.png": 197,
	"./backgrounds/paper/legal-team-prosecutor.png": 198,
	"./backgrounds/paper/legal-team-prosecutor2.png": 199,
	"./backgrounds/paper/sentencing.png": 200,
	"./backgrounds/paper/voting.png": 201,
	"./backgrounds/paper/welcome.png": 202,
	"./backgrounds/paper/witnesses.png": 203,
	"./backgrounds/sentencing-1.jpg": 204,
	"./backgrounds/sentencing-2.jpg": 205,
	"./backgrounds/voting-1.jpg": 206,
	"./backgrounds/voting-2.jpg": 207,
	"./backgrounds/welcome-1.jpg": 208,
	"./backgrounds/welcome-2.jpg": 209,
	"./backgrounds/welcome-3.jpg": 210,
	"./backgrounds/whiteoverlay.png": 211,
	"./backgrounds/witnesses-1.jpg": 212,
	"./backgrounds/witnesses-2.jpg": 213,
	"./backgrounds/witnesses-3.jpg": 214,
	"./backgrounds/witnesses-legal-team-defendant.jpg": 215,
	"./backgrounds/witnesses-prosecutor.jpg": 216,
	"./backgrounds/witnesses-witnesses.jpg": 217,
	"./cookie/cookies.svg": 218,
	"./icon-loading-2.svg": 219,
	"./icon-loading.svg": 220,
	"./icon-mute-intro.svg": 221,
	"./icon-mute.svg": 222,
	"./icon-mute2.svg": 223,
	"./icon-next.svg": 224,
	"./icon-notmute-intro.svg": 225,
	"./icon-orientation.svg": 226,
	"./icon-pause.svg": 85,
	"./icon-pause2.svg": 227,
	"./icon-play.svg": 86,
	"./icon-play2.svg": 228,
	"./icon-prev.svg": 229,
	"./icon-unmute.svg": 230,
	"./logo-cgl.svg": 79,
	"./logo-courts-of-denmark.svg": 231,
	"./logo-courts-of-denmark2.svg": 232,
	"./next.svg": 233,
	"./prev.svg": 234
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 72;